import { instance } from "api/apiBase";
import { PaginatedResponse } from "shared/types";
import {
  BaseLandlordSurvey,
  CreateSurveyPayload,
  DetailedLandlordSurvey,
  UpdateSurveyPayload
} from "./types/types";

const BASE = "/portal/v1/premium_rental_history/survey_templates";

export const landlordSurveyApi = {
  getSurveys: async (): Promise<BaseLandlordSurvey[]> => {
    const { data } =
      await instance.get<PaginatedResponse<BaseLandlordSurvey>>(BASE);
    return data.items;
  },

  getSurveyByIdentifier: async (
    identifier: string
  ): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.get<DetailedLandlordSurvey>(
      `${BASE}/${identifier}`
    );
    return data;
  },

  createSurvey: async (
    payload: CreateSurveyPayload
  ): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.post<DetailedLandlordSurvey>(BASE, payload);
    return data;
  },

  updateSurvey: async (
    identifier: string,
    payload: UpdateSurveyPayload
  ): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.patch<DetailedLandlordSurvey>(
      `${BASE}/${identifier}`,
      payload
    );
    return data;
  }
};
